import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { DropdownButton, Dropdown } from 'react-bootstrap'

// styles
import colors from '../../styles/colors'

// images
import DownImg from '../../assets/image/arrow/ic-down.svg'

const DropDown = ({
  options, // 드롭다운 아이템
  defaultOption, // 디폴트 표시
  setOption,
  className,
  isPageUnit, // 보기 표시 여부
  isIndex, // 옵션명 대신 인덱스 값 체크
  isSettlement, // 정산 페이지 여부
  isStart, // 시작일
  compareItem, // 드롭다운 마감일이 시작일보다 작아질 수 없게
}) => {
  const [selected, setSelected] = useState(defaultOption ?? options[0])
  const [isActive, setIsActive] = useState(false) // 활성화 상태 추가

  const handleOptionSelect = (option, idx) => {
    setSelected(option)
    setOption(!isIndex ? option : idx)
    setIsActive(false)
  }
  const handleDropdownToggle = (isOpen) => {
    setIsActive(isOpen) //react-bootstrap 제공하는 이벤트 콜백함수 매개변수(true/false)
  }

  useEffect(() => {
    setSelected(defaultOption ?? options[0])
  }, [defaultOption])

  const getCompareItem = (dropItem, target, flag) => {
    if (!dropItem || !target) return false

    const item = Number(dropItem.replace(/[^0-9]/g, ''))
    const targetItem = Number(target)

    // return item < targetItem

    switch (flag) {
      // 시작일
      case 0:
        return item > targetItem

      // 마감일
      case 1:
        return item < targetItem
    }
  }

  return (
    <DropWrap className={className}>
      <Dropdown onToggle={handleDropdownToggle}>
        <Dropdown.Toggle
          variant="outline-secondary"
          id="input-group-dropdown-1"
        >
          {isPageUnit ? `${selected}개씩 보기` : `${selected}`}
          <ArrowImg isActive={isActive} src={DownImg} />
        </Dropdown.Toggle>
        {options && options?.length > 0 && (
          <Dropdown.Menu>
            {/* {options?.map((option, idx) => (
              <Dropdown.Item
                key={option}
                href="#"
                onClick={() => handleOptionSelect(option, idx)}
              >
                {option}
              </Dropdown.Item>
            ))} */}
            {options?.map((option, idx) => {
              let isPrevent = false

              // 정산페이지 드롭다운
              // 시작일: 시작일 > 마감일 막음
              // 마감일: 마감일 < 시작일 막음
              if (isSettlement) {
                isPrevent = getCompareItem(option, compareItem, isStart ? 0 : 1)
              }

              return (
                <Dropdown.Item
                  key={option}
                  href="#"
                  onClick={() => {
                    if (!isPrevent) {
                      handleOptionSelect(option, idx)
                    }
                  }}
                >
                  <DropdownItem isPrevent={isPrevent}>{option}</DropdownItem>
                </Dropdown.Item>
              )
            })}
          </Dropdown.Menu>
        )}
      </Dropdown>
    </DropWrap>
  )
}

export default DropDown

const DropWrap = styled.div`
  width: 100%;

  #input-group-dropdown-1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .dropdown-toggle {
    text-align: left;
    color: #000;
    width: 100%;
    height: 48px;
    overflow: hidden;

    @media ${(props) => props.theme.mobile} {
      /* max-width: 136px; */
      font-size: 14px;
      height: 36px;
    }
  }
  .btn-outline-secondary {
    background-color: ${colors.W1};
    color: ${colors.BK};
    border: solid 1px #e5e5e5;
  }
  .btn-outline-secondary:hover {
    background-color: ${colors.W1};
    color: ${colors.BK};
    border: solid 1px #e5e5e5;
  }
  .dropdown-item:hover {
    background-color: ${colors.W1};
    color: ${colors.mainG};
  }
  .dropdown-toggle::after {
    position: relative;
    top: 0.35em;
    float: right;
    color: #a8a8a8;
    display: none !important;
  }
  .dropdown-menu {
    width: 100% !important;
    min-width: 125px;
    padding-bottom: 0px;
    overflow: hidden;
    @media ${(props) => props.theme.mobile} {
      font-size: 14px;
    }
  }
  .dropdown-item {
    width: 100%;
    margin-top: 4px;
    margin-bottom: 10px;
  }
`

const ArrowImg = styled.img`
  width: 12px;
  height: 12px;
  cursor: pointer;
  transition: transform 0.5s ease;
  transform: ${(props) => (props.isActive ? `rotate(180deg)` : `rotate(0deg)`)};
`

const DropdownItem = styled.div`
  color: ${(props) => props.isPrevent && `${colors.G2}`};
  cursor: ${(props) => props.isPrevent && `not-allowed`};
`
